const RecordingControls = Object.freeze({
  none: "none",
  start: "start",
  start_pause: "start_pause",
});

export default RecordingControls;
